import moment from 'moment';
const regexCaracter = /^[a-zA-Z0-9]+$/;
const CryptoJS = require('crypto-js');

export const Encrypt = (data, key) => CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();

export const Decrypt = (data, key) => {
  const bytes = CryptoJS.AES.decrypt(data.toString(), key);

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const doTruncateText = (text, limit) => {
  if (text.length < limit || text === null) return text;

  limit--;
  let last;

  last = text.substr(limit - 1, 1);

  while (last !== ' ' && limit > 0) {
    limit--;
    last = text.substr(limit - 1, 1);
  }

  last = text.substr(limit - 2, 1);

  if (last == ',' || last == ';' || last == ':') return text.substr(0, limit - 2) + '...';

  if (last == '.' || last == '?' || last == '!') return text.substr(0, limit - 1);

  return text.substr(0, limit - 1) + '...';
};

export const getTimeZone = () => {
  var offset = new Date().getTimezoneOffset(),
    o = Math.abs(offset);
  return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2);
};

export const typeDecimal = value => {
  if (typeof value == 'number') {
    let currencySymbol = 'R$';

    let number = parseFloat(value).toFixed(2).split('.');
    number[0] = number[0].split(/(?=(?:...)*$)/).join('.');

    return currencySymbol + ' ' + number.join(',');
  }

  return value;
};

export const typeZipCode = value => {
  if (value && regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.length == 8) {
      let regex = /([0-9]{5})([0-9]{3})/;
      let valueSplit = regex.exec(valueString);

      return valueSplit[1] + '-' + valueSplit[2];
    }
  }

  return value;
};

export const typePhone = value => {
  if (value && regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length == 10) {
      let regex = /([0-9]{2})([0-9]{4})([0-9]{4})/;
      let valueSplit = regex.exec(valueString);

      return '(' + valueSplit[1] + ') ' + valueSplit[2] + '-' + valueSplit[3];
    } else if (valueString.toString().length == 11) {
      let regex = /([0-9]{2})([0-9]{5})([0-9]{4})/;
      let valueSplit = regex.exec(valueString);

      return '(' + valueSplit[1] + ') ' + valueSplit[2] + '-' + valueSplit[3];
    }
  }

  return value;
};

export const typeCpf = value => {
  if (value && regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length == 11) {
      let regex = /(\d{3})(\d{3})(\d{3})(\d{2})$/;
      let valueSplit = regex.exec(valueString);

      return valueSplit[1] + '.' + valueSplit[2] + '.' + valueSplit[3] + '-' + valueSplit[4];
    }
  }

  return value;
};

export const typeCNPJ = value => {
  if (value && regexCaracter.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length == 14) {
      let regex = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g;
      let valueSplit = regex.exec(valueString);

      return valueSplit[1] + '.' + valueSplit[2] + '.' + valueSplit[3] + '/' + valueSplit[4] + '-' + valueSplit[5];
    }
  }

  return value;
};

export const typePercentageSymbol = value => {
  if (/\d */g.test(value)) {
    let valueString = value.toString();

    if (valueString.toString().length > 0) {
      let valueSplit = valueString.replace(/[ÁÉÍÓÚáéíóúâêîôûàèìòùÇçãõ/.,~!@#$%&_-]*/g, '').replace(/[a-z-A-Z]*/g, '');

      return valueSplit + '%';
    }
  }

  return value;
};

export const formatEntry = entry => {
  let redirect = {};
  entry
    .replace(/'/g, '')
    .split(';')
    .forEach(element => {
      redirect[element.split('=')[0].trim()] = element.split('=')[1];
    });

  return redirect;
};

export const formatEntryFromEntryFields = function (entryFields, data, index) {
  let redirectParams = {};
  let indexSelectedField = index ? index : 0;
  if (Array.isArray(entryFields) && Array.isArray(data.values) && data.values.length) {
    entryFields.forEach(fieldName => {
      redirectParams[fieldName] = data.values[indexSelectedField][fieldName];
    });

    // Caso tenha tela com páginação externa, é recuperado os filtro a partir da data.
    const { limit, offset, sortBy, sortDesc } = data?.values[0] || {};

    Object.assign(redirectParams, {
      limit,
      offset,
      sortBy,
      sortDesc
    });
  }

  return redirectParams;
};

export const setPagesToClearDefaultFilter = (data, destinationPage = null) => {
  if (((typeof data === 'boolean' && data) || data == 1) && destinationPage) {
    return [destinationPage];
  }

  if (typeof data === 'string') {
    return data.split(';');
  }

  if (Array.isArray(data)) {
    return data;
  }

  return [];
};

export const isReport = query => query.hasOwnProperty('procedure') && query.hasOwnProperty('id_dashboard');

export const downloadFile = (data, contentType, extension, fileName) => {
  let blob;

  // Mapeamento de tipos de dados para funções de conversão
  const dataTypeHandlers = {
    ArrayBuffer: data => new Blob([data], { type: contentType }),
    HexString: data => {
      const byteNumbers = [];
      for (let i = 0; i < data.length; i += 2) {
        byteNumbers.push(parseInt(data.substr(i, 2), 16));
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: contentType });
    },
    Base64String: data => b64toBlob(data, contentType, 512),
    Blob: data => data
  };

  // Determina o tipo de dados e usa a função de conversão apropriada
  if (data instanceof ArrayBuffer) {
    blob = dataTypeHandlers.ArrayBuffer(data);
  } else if (typeof data === 'string' && isHexFile(data)) {
    blob = dataTypeHandlers.HexString(data);
  } else if (typeof data === 'string' && isBase64File(data)) {
    const base64Content = data.split(',')[1]; // Extrai apenas o Base64 puro
    blob = dataTypeHandlers.Base64String(base64Content); // Passa o Base64 puro
  } else if (data instanceof Blob) {
    blob = dataTypeHandlers.Blob(data);
  } else {
    blob = b64toBlob(data, contentType, 512);
  }

  const blobUrl = window.URL.createObjectURL(blob);

  const tag = document.createElement('a');
  tag.className = 'download-file';
  tag.style.display = 'none';
  tag.href = blobUrl;
  tag.download = fileName ? `${fileName}.${extension}` : `file-${new Date().getTime()}.${extension}`;

  document.body.appendChild(tag);
  tag.click();
  window.URL.revokeObjectURL(blobUrl);
  document.body.removeChild(tag);
};

export const isBase64File = str => {
  const regex = /^data:[a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+;base64,[a-zA-Z0-9+/]+=*$/;
  return regex.test(str);
};

export const isHexFile = str => {
  const regex = /^[0-9a-fA-F]+$/;
  return regex.test(str);
};

export const b64toBlob = (b64Data, contentType, sliceSize) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

export const formatValue = (schema, value) => {
  const types = ['date', 'dateTime', 'decimal', 'zipcode', 'phone', 'cpf', 'cnpj', 'percentageSymbol'];
  if (types.indexOf(schema.type) >= 0) {
    return {
      date: value => (value == null ? '' : moment(value).format('DD/MM/YYYY')),
      dateTime: value => (value == null ? '' : moment(value).format('DD/MM/YYYY h:mm:ss')),
      decimal: value => typeDecimal(value),
      zipcode: value => typeZipCode(value),
      phone: value => typePhone(value),
      cpf: value => typeCpf(value),
      cnpj: value => typeCNPJ(value),
      percentageSymbol: value => typePercentageSymbol(value)
    }[schema.type](value);
  }

  return value;
};

export const getIcon = type => {
  switch (true) {
    case type.includes('pdf'):
      return 'fas fa-file-pdf';
    case type.includes('jpeg'):
    case type.includes('png'):
    case type.includes('gif'):
      return 'far fa-file-image';
    case type.includes('excel'):
    case type.includes('spreadsheet'):
      return 'far fa-file-excel';
    case type.includes('wordprocessingml'):
    case type.includes('docx'):
    case type.includes('doc'):
      return 'far fa-file-word';
    case type.includes('zip'):
      return 'far fa-file-archive';
    case type.includes('text'):
    case type.includes('txt'):
      return 'far fa-file-alt';
    default:
      return 'far fa-file';
  }
};

export const formatBytes = bytes => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
};

export const convertSecondInMilisecounds = seconds => {
  return ((seconds % 60000) * 1000).toFixed(0);
};

export const compilerOperationDate = (instruction, filledAllDaysOnMonth) => {
  const regexAliasDateDinamic = /[a-zA-Z]+$/;
  const regexDateDinamic = /[DMY][\-\+][\d]*$/;
  const regexDateFixed = /\d{4}-\d{2}-\d{2}/;

  const aliasInstruction = {
    today: 'D+0',
    nextWeek: 'D+7',
    nextMonth: 'M+1'
  };

  // Retorna erro ao receber parametro indesejavel
  if (
    !regexAliasDateDinamic.test(instruction) &&
    !regexDateDinamic.test(instruction) &&
    (!regexDateFixed.test(instruction) || (regexDateFixed.test(instruction) && !isValidDate(new Date(instruction))))
  ) {
    console.error('Não foi definido uma data ou código correto!');
    return undefined;
  }

  // Caso o parametro seja uma data fixa valida, retorna ela mesma
  if (regexDateFixed.test(instruction) && isValidDate(new Date(instruction))) {
    return instruction;
  }

  // Caso receba um ALIAS, converte para o codigo respectivo
  if (regexAliasDateDinamic.test(instruction)) {
    instruction = aliasInstruction[instruction];

    if (instruction === undefined) {
      console.error('Não foi definido a palavra chave como identificador de range no Calendário!');
      return undefined;
    }
  }

  // Realiza a operação de [soma ou subtração] de data
  const operator = instruction[1];
  const arrayValues = instruction.split(operator);
  return convertAliasData(arrayValues[0], +(operator + arrayValues[1]), filledAllDaysOnMonth);
};

export function convertAliasData(part, value, filledAllDaysOnMonth) {
  const data = new Date();

  const dateParts = {
    day: data.getDate(),
    month: data.getMonth(),
    year: data.getFullYear()
  };

  const objMap = {
    D: new Date(dateParts['year'], dateParts['month'], data.getDate() + value),
    M: new Date(
      dateParts['year'],
      filledAllDaysOnMonth ? data.getMonth() + (value + 1) : data.getMonth() + value,
      filledAllDaysOnMonth ? '00' : dateParts['day']
    ),
    Y: new Date(data.getFullYear() + value, dateParts['month'], dateParts['day'])
  };

  return moment(objMap[part]).format('YYYY-MM-DD');
}

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

// Função generica que recebe um array com dados(Array) para renderizar um Treeview do vuetify
//  Retornar o mesmo array com um acressimo em cada nó, contendo seu diretório em campo string
export const incrementTreeDataWithDirectoryString = (treeDataArray, stack = []) => {
  const addItem = (item, stack = []) => {
    if (item.id /*&& !(item.dir) */) {
      stack.push(item.name);
      item.dir = stack.join('/');
    }
  };

  treeDataArray.map(item => {
    if (item.children) {
      addItem(item, stack);
      incrementTreeDataWithDirectoryString(item.children, stack);
      stack.pop();
      return;
    }
    addItem(item, stack, true);
    stack.pop();
  });

  return treeDataArray;
};

// Função auxiliar da função filterData.
//  Podendo ser utilizada para setar novos valores filtrados a partir de initialModel e/ou Model.
//    Em determinados casos de uso, o json poderá vir com filters vazio. Com isso é possível fazer requisições
//      simulando primeira chamada e/ou requisições para recuperar todos os dados.
export const filterDataAccordingPageMode = ({ mode, filters, currentData }) => {
  if (mode === 'list' && Array.isArray(currentData)) {
    if (!filters.length) return {};

    return currentData.map(modelInLine => filterData(filters, modelInLine, false));
  } else {
    return filterData(filters, currentData, false);
  }
};

// Função generica para filtrar dados em um determinado DADO/MODEL, fazendo com que apenas
//  determinadas propriedades de um OBJETO seja filtrado.
export const filterData = (filters = [], currentData = {}, uniquePushArray = false) => {
  // Caso seja filtrado apenas UMA propriedade, o retorno será apenas do VALUE, prevalecendo o mesmo tipo de dado.
  //   Caso queira fazer com que o retorno de apenas uma propridade seja colocado dentro de um Array, utilize uniquePushArray como TRUE.
  //    Quando filtrado por mais de uma propriedade, é retornado um Objeto com os campos filtrados.
  const sendUnique = filters.length === 1;

  const isDataToBeFilteredIsStructered =
    sendUnique && (Array.isArray(currentData[filters[0]]) || typeof currentData[filters[0]] === 'object');
  const IShouldJustInsertTheValueWhenDataIsStructured = sendUnique && isDataToBeFilteredIsStructered;

  let newDataFiltered = IShouldJustInsertTheValueWhenDataIsStructured ? [] : {};

  filters.forEach(filter => {
    if (IShouldJustInsertTheValueWhenDataIsStructured) {
      let currentDataIsArray = Array.isArray(currentData[filter]);

      if (!currentDataIsArray && uniquePushArray) {
        newDataFiltered.push(currentData[filter]);
        return;
      }
      newDataFiltered = currentData[filter];
      return;
    }
    Object.assign(newDataFiltered, { [filter]: currentData[filter] });
  });

  return sendUnique && uniquePushArray && !Array.isArray(newDataFiltered) ? [newDataFiltered] : newDataFiltered;
};

// Função generica para normalizar um texto para pesquisa removendo acentos e caracteres especiais como "ç"
export const normalizeText = text => {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

// Função generica para verificar se uma string começa com "{" e termina com "}"
export const isValidInterpoledValue = value => {
  const regex = /^\{.*\}$/;

  if (Array.isArray(value)) {
    return value.every(item => regex.test(item));
  }

  return regex.test(value);
};

// Função que extrai a string do valor interpolado entre "{}" chaves e remove espaços e aspas
export const extractAndCleanInterpoledValue = value => {
  if (value == null || value == undefined) {
    return '';
  }
  if (typeof value === 'number') {
    return value;
  }
  return value.replace(/^\{(.*)\}$/, '$1').replace(/['"\s]/g, '');
};

export const tabHeaderHasResetDefaultFilter = (formNode, page) => {
  let objContent = null;
  if ('tabs' in formNode && 'content' in formNode.tabs && 'headers' in formNode.tabs) {
    objContent = formNode.tabs.content;
  }
  if (!objContent) return false;

  let foundKey = null;
  for (const key in objContent) {
    if (objContent[key].page.page === page) {
      foundKey = key;
      break;
    }
  }
  if (!foundKey) return false;

  const foundHeader = formNode.tabs.headers[foundKey - 1];
  if (foundHeader && foundHeader.resetDefaultFilter) {
    return true;
  }

  return false;
};

export const navigateToPropertyInModel = (model, path) => {
  return path.split('.').reduce((obj, prop) => {
    if (!obj) return null;

    const [propName, propIndex] = prop.split('[');
    if (propIndex) {
      const index = propIndex.replace(']', '');
      // Check if index is a number
      if (!isNaN(index)) {
        return obj[propName] ? obj[propName][index] : null;
      }
    }

    return obj[prop];
  }, model);
};

const B64_TOKEN = '__B64__';

export const toBase64 = (value) => {
  const bytes = new TextEncoder().encode(value);
  const binString = String.fromCodePoint(...bytes);

  return B64_TOKEN + btoa(binString) + B64_TOKEN;
}